<template>
    <div class="detail">
        <el-dialog title="详情" :visible.sync="dialogVisible" width="700px">
            <div class="main" v-loading="load" v-if="infoData">
                <el-form label-width="120px" label-position="left">
                    <el-form-item label="经销商级别：">
                        <p>{{ levelList[Number(infoData.level) - 1] }}</p>
                    </el-form-item>

                    <el-form-item label="所属上级：" v-if="infoData.parent_name">
                        <p>{{ infoData.parent_name }}</p>
                    </el-form-item>

                    <el-form-item label="经销商名称：">
                        <p>{{ infoData.name }}</p>
                    </el-form-item>

                    <el-form-item label="经销商地址：">
                        <p>{{ infoData.address }}</p>
                    </el-form-item>

                    <el-form-item label="负责人姓名：">
                        <p>{{ infoData.principals_name }}</p>
                    </el-form-item>

                    <el-form-item label="负责人电话：">
                        <p>{{ infoData.principals_phone }}</p>
                    </el-form-item>

                    <el-form-item label="负责人邮箱：">
                        <p>{{ infoData.principals_email }}</p>
                    </el-form-item>

                    <el-form-item label="授权区域：">
                        <p>{{ infoData.area_names | strFmt }}</p>
                    </el-form-item>

                    <el-form-item label="授权分类：">
                        <p>{{ infoData.product_category_names | strFmt }}</p>
                    </el-form-item>

                    <el-form-item label="授权起止日期：">
                        <p>{{ `${infoData.start_time} ~ ${infoData.end_time}` }}</p>
                    </el-form-item>

                    <el-form-item label="产品监控：" v-if="infoData.agency_product_count > 0">
                        <el-button type="primary" size="small" @click="selPro('monitotr', editId)">已添加 {{ infoData.agency_product_count }} 个，点击查看</el-button>
                    </el-form-item>

                    <el-form-item label="授权信息：" v-if="infoData.agency_authorization_images != ''">
                        <div v-for="(item, index) in infoData.agency_authorization_images" :key="index">
                            <el-form-item>
                                <el-image v-if="isImage(item)" style="width: 200px; height: 200px" :src="item" :preview-src-list="[item]"> </el-image>
                                <el-link v-else type="primary" @click="down(item)" class="lh24">在线查看</el-link>
                            </el-form-item>
                        </div>
                    </el-form-item>

                    <el-form-item label="店铺数量：" v-if="infoData.agency_shop_count > 0">
                        <p>{{ infoData.agency_shop_count }}</p>
                    </el-form-item>
                </el-form>
            </div>
            <el-empty v-else description="暂无内容！"></el-empty>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="medium" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
export default {
    data() {
        return {
            dialogVisible: false,
            infoData: [],
            load: false,
            levelList: ["一级", "二级", "三级"],
            editId: 0,
        };
    },
    filters: {
        strFmt(val) {
            if (val) {
                let str = "";
                for (let v in val) {
                    str += `${val[v][val[v].length - 1]}，`;
                }
                return str.substring(0, str.length - 1);
            }
            return "-";
        },
    },
    mounted() {},
    created() {},
    computed: {
        ...mapGetters(["getToken"]),
    },
    methods: {
        ...mapActions({
            agencyDetail: "brand/agencyDetail", //详情
        }),
        selPro(type, id) {
            this.$emit("selectProduct", type, id);
        },
        isImage(val) {
            let ext = val.split(".").pop().toLowerCase();
            return ext == "jpg" || ext == "png" || ext == "jpeg";
        },
        down(url) {
            window.open(url);
        },
        getDetail(id) {
            this.editId = id;
            this.load = true;
            let opt = {
                token: this.getToken, // 必填 登录token
                id: id,
            };
            this.agencyDetail(opt).then(({ data }) => {
                this.load = false;
                if (data.code == 1) {
                    this.infoData = data.data;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.detail {
    .el-form {
        max-height: 500px;
        overflow-y: auto;
        &::-webkit-scrollbar-track-piece {
            background: #d3dce6;
        }

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: #99a9bf;
            border-radius: 20px;
        }
    }
}
</style>